import React, { useEffect, useState } from "react";
import "../../Analyst/Dashboard/analysisDashboard.css";
import { MdPersonAdd, MdRemoveRedEye } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import AddNewUser from "./addNewUserModal";
import CompanyAdminSideBar from "./companyAdminSideBar";
import companyAdminService from "../../../components/Services/companyAdmin.service";
import PlantDetails from "../Registration/plantDetails";
import ConsumerDetails from "../Registration/consumerDetails";
import RoleBasedApiPermissions from "./roleBasedApiPermissions";
import {
  initialCallForRequiredData,
  initialCallForRequiredDataRoleSpecific,
} from "../../../store/Registartion/actions";
import { useDispatch, useSelector } from "react-redux";
import { SET_RESET_REGISTRATION_STATE } from "../../../store/Registartion/types";
import SelectTraderModal from "./selectTraderModal";
import { CircularProgress } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AgreementTemplateModal from "../../../components/AgrTemplateModal/AgreementTemplateModal";

const CompanyAdminDashboard = () => {
  const [showPlantDetailsModal, setShowPlantDetailsModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showTrader, setShowTrader] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedUser, setSelectedUser] = useState(0);

  const [loader, setLoader] = useState(true);
  const [indOpen, setIndOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uName = useSelector((state) => state?.sessionState?.companyDisplayName);
  const companiesList = useSelector((state) => state?.sessionState?.userList);

  const handleTraderSelectPopup = () => {
    setShowTrader(!showTrader);
  };
  const handleUserPopup = () => {
    setShowUserModal(!showUserModal);
  };
  const handleAddRole = (role) => {
    setSelectedRole(role);
    setShowPlantDetailsModal(true);
    dispatch({ type: SET_RESET_REGISTRATION_STATE });
    initialCallForRequiredData({
      dispatch,
      reqData: role,
    });
    initialCallForRequiredDataRoleSpecific({ reqData: role, dispatch });
  };

  const handleAddRoleClose = () => {
    setShowPlantDetailsModal(false);
  };

  const handleUserProfileEdit = () => {
    navigate("/admin_comp_userProfile");
  };

  const getAllCompanyAdminUsers = () => {
    setLoader(true);
    companyAdminService
      .getAllCompanyAdminUsers()
      .then((response) => {
        if (response?.data?.code === 200) {
          setUsersData(response?.data?.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
        
      })
      .catch((error) => {
        console.log("Api Call Error: ", error);
        setLoader(false);
      });
  };

  const handleUserSelection = (index) => {
    setSelectedUser(index);
  };
  const [selectedRolePermissions, setSelectedRolePermissions] = useState({});
  const [userPermissionsModal, setUserPermissionsModal] = useState(false);

  const handleUserPermissionsModal = (item) => {
    setSelectedRolePermissions(item);
    setUserPermissionsModal(!userPermissionsModal);
  };
  useEffect(() => {
    getAllCompanyAdminUsers();
  }, []);

  const handleAgrementTemplate = () => {
    setIndOpen(true);
  };

  const handleCloseAgr = () => {
    setIndOpen(false);
  };


  
  const isDisabled = true;

  return (
    <>
      {indOpen && (
        <AgreementTemplateModal open={indOpen} handleClose={handleCloseAgr} />
      )}
      {showUserModal && (
        <AddNewUser
          isOpen={showUserModal}
          handleUserPopupClose={handleUserPopup}
          getAllCompanyAdminUsers={getAllCompanyAdminUsers}
        />
      )}
      {showTrader && (
        <SelectTraderModal
          isOpen={showTrader}
          handleTraderSelectPopup={handleTraderSelectPopup}
          getAllCompanyAdminUsers={getAllCompanyAdminUsers}
        />
      )}
      {showPlantDetailsModal && (
        <Modal
          show={showPlantDetailsModal}
          onHide={() => handleAddRoleClose()}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Add New{" "}
              <span>
                {(selectedRole === "GENERATOR" && "Generator") ||
                  (selectedRole === "CONSUMER" && "Consumer") ||
                  selectedRole}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="m-3">
            {selectedRole === "GENERATOR" ? (
              <PlantDetails
                handleAddRoleClose={handleAddRoleClose}
                getAllCompanyAdminUsers={getAllCompanyAdminUsers}
              />
            ) : selectedRole === "CONSUMER" ? (
              <ConsumerDetails
                handleAddRoleClose={handleAddRoleClose}
                getAllCompanyAdminUsers={getAllCompanyAdminUsers}
              />
            ) : (
              ""
            )}
          </Modal.Body>
        </Modal>
      )}
      {userPermissionsModal && (
        <Modal
          show={userPermissionsModal}
          onHide={() => handleUserPermissionsModal()}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              User Permissions - {selectedRolePermissions?.role?.role}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="m-3">
            <RoleBasedApiPermissions
              selectedData={selectedRolePermissions}
              getAllCompanyAdminUsers={getAllCompanyAdminUsers}
              handleUserPermissionsModal={handleUserPermissionsModal}
            />
           
          </Modal.Body>
        </Modal>
      )}
      <div className="full-screen-bg">
        <CompanyAdminSideBar
          usersData={usersData}
          userSelection={handleUserSelection}
          getAllCompanyAdminUsers={getAllCompanyAdminUsers}
        />
        {loader ? (
          <div className="popup-background">
            <CircularProgress />
          </div>
        ) : (
          <section className="dashboard-area">
            <div>
              <div className="users-view-wrap justify-content-end">
                <div className="table-filters">
                  {companiesList?.[0]?.companyRoles?.some(
                    (item) => item.role?.role === "BANKING"
                  ) && (
                    <div
                      className="add-new-user"
                      onClick={handleAgrementTemplate}
                    >
                      Select LOI Template
                    </div>
                  )}
                </div>
                {/* <div className="table-filters">
          {
            process.env.REACT_APP_ENV !== "prod" && (
              <div className="add-new-user" onClick={handleTraderSelectPopup}>
                Select Trader/Aggregator
              </div>
            )
          }
        </div> */}
                <div className="table-filters">
                  <div className="add-new-user" onClick={handleUserPopup}>
                    <MdPersonAdd className="me-2" /> Add New User
                  </div>
                </div>
                {!companiesList?.[0]?.companyRoles?.some(
                  (item) => item.role?.role === "GENERATOR"
                ) && (
                  <div className="table-filters">
                    <div
                      className="add-new-user"
                      onClick={() => handleAddRole("GENERATOR")}
                    >
                      <MdPersonAdd className="me-2" /> Add New Generator
                    </div>
                  </div>
                )}
                {!companiesList?.[0]?.companyRoles?.some(
                  (item) => item.role?.role === "CONSUMER"
                ) && (
                  <div className="table-filters">
                    <div
                      className="add-new-user"
                      onClick={() => handleAddRole("CONSUMER")}
                    >
                      <MdPersonAdd className="me-2" /> Add New Consumer
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr className=" horizontal-line" />

            <div className="table-responsive doc-cus-table">
              <table className="cus-table table-bordered my-documents-table bg-white mt-3">
                <thead className="table-header">
                  <tr>
                    <th>S. No</th>
                    <th>Company Name</th>
                    <th>Account Type</th>
                    <th>Permissions</th>
                  </tr>
                </thead>
                {usersData?.[selectedUser]?.userCompanies?.map((item, i) => (
                  <tbody key={i}>
                    {item?.companyRoles?.map((roles, roleIndex) => (
                      <tr key={roleIndex}>
                        <td>{roleIndex + 1}</td>
                        <td width="20%">{uName}</td>
                        <td>{roles?.role?.role}</td>
                        <td>
                          {roles?.role?.role == "COMPANY_ADMIN" ||
                          roles?.role?.role == "TRADER" ? (
                            <VisibilityOffIcon
                              size={25}
                              className="action-edit-btn-off"
                            />
                          ) : (
                            <MdRemoveRedEye
                              size={25}
                              className="action-edit-btn"
                              onClick={
                                isDisabled
                                  ? undefined
                                  : () => handleUserPermissionsModal(roles)
                              }
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ))}
              </table>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default CompanyAdminDashboard;
